import React, { useEffect, useState } from "react";
import GraphiQL from "graphiql";
import { Auth } from "aws-amplify";
import awsExports from "../../aws-exports";
import "graphiql/graphiql.css";

function SchemaExplorer() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    Auth.currentSession().then((session) => {
      setToken(session.getIdToken().getJwtToken());
    });
  }, []);

  const fetcher = async (graphQLParams) => {
    const response = await fetch(awsExports.aws_appsync_graphqlEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify(graphQLParams),
    });
    return response.json();
  };

  if (!token) return <div style={{ padding: "20px" }}>Loading...</div>;

  return (
    <div style={{ height: "100vh" }}>
      <GraphiQL fetcher={fetcher} />
    </div>
  );
}

export default SchemaExplorer;
